import type { AdminUseSelectDto } from '@@types/api.types';
import { TooltipComponent } from '@components/core/tooltip.component';
import type React from 'react';

type AdminUseDependenciesProps = {
  useItem: AdminUseSelectDto;
};

export const AdminUseDependencies: React.FC<AdminUseDependenciesProps> = (props) => {
  const { useItem } = props;

  const dependencies = [
    { label: 'Technology Uses', count: useItem.dependencyCounts.technologyUsesCount },
    { label: 'Assessments', count: useItem.dependencyCounts.assessmentsCount },
    { label: 'MA Technology Uses', count: useItem.dependencyCounts.missionAssessmentTechnologyUsesCount },
    { label: 'MA Effects', count: useItem.dependencyCounts.missionAssessmentEffectsCount },
    { label: 'MA Requests', count: useItem.dependencyCounts.missionAssessmentRequestsCount },
    { label: 'Survey Use Domains', count: useItem.dependencyCounts.surveyUseDomainsCount },
    { label: 'Question Filters', count: useItem.dependencyCounts.questionFiltersCount },
  ].filter((dep) => dep.count > 0);

  return (
    <div className="p-4 rounded-lg border border-gray-200 bg-white">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-gray-900">Usage</h3>
          <TooltipComponent side="top">
            Entities (technologies, assessments, survey use domains, etc.) that are using this use case.
          </TooltipComponent>
        </div>

        {useItem.totalDependencies === 0 ? (
          <p className="text-sm text-gray-500">This use is not being used.</p>
        ) : (
          <div className="space-y-1 text-sm">
            {dependencies.map((dep) => (
              <div
                key={dep.label}
                className="flex justify-between"
              >
                <span className="text-gray-600">{dep.label}:</span>
                <span className="font-medium">{dep.count}</span>
              </div>
            ))}
            <div className="flex font-semibold justify-between pt-1 border-t border-gray-200">
              <span className="text-gray-600">Total:</span>
              <span className="font-medium">{useItem.totalDependencies}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
